<template>
  <div class="contentHome">
    <div class="centerPage">
      <tabCommon></tabCommon>
      <div class="right">
        <div class="title flex">
          <span>系统通知</span>
        </div>
        <div class="formUserInfo">
          <div>
            <el-table
                :data="data"
                @expand-change="read"
                style="width: 100%">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="left" inline>
                    <el-form-item label="详情">
                      <div class="narrate" v-html="props.row.content" style="white-space: pre-line;"></div>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column
                  label="消息标题"
                  prop="title">
              </el-table-column>
              <el-table-column
                  align="right"
                  label="是否已读"
                  prop="isRead">
                <template slot-scope="props">
                  <el-tag v-if="props.row.isRead===1" type="success">已读</el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="empty" v-if="data.length===0">
            <img src="../../assets/img/no.png" alt="" width="200">
            <p>这里什么都没有</p>
          </div>
          <el-pagination
              class="pagination"
              background
              prev-text="Prev"
              next-text="Next"
              @current-change="skipPage"
              :current-page="page.current"
              :page-size="page.size"
              layout="prev, pager, next"
              :total="page.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../../api/common";
import {mapMutations} from 'vuex';

export default {
  name: "userMessage",
  data() {
    return {
      page: {
        current: 1,
        size: 10,
        total: 0,
        rows: [],

        status: -1,
      },
      data: [],
    }
  },
  components: {
    'tabCommon': () => import('./tabCommon'),
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapMutations(['setMessage']),
    getData() {
      let that = this;
      this.$ajax
          .get(common.api.message.system.page.replace("{current}/{size}", this.page.current + "/" + this.page.size))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.data = res.data.rows;
              that.page.total = res.data.total;
            }
          })
    },
    read(row) {
      if (row.isRead === 0) {
        let that = this;
        this.$ajax
            .post(common.api.message.system.read.replace("{id}", row.id))
            .then(function (res) {
              if (res.data.status === 'success') {
                row.isRead = 1
                // that.getData();
                that.countNotRead()
              }
            })
      }
    },
    skipPage(cur) {
      this.page.current = cur;
      this.getData();
    },
    countNotRead() {
      let that = this;
      this.$ajax.get(common.api.message.system.countNotRead)
          .then(function (res) {
            if (res.data.status === 'success') {
              // that.countNotReadMessage = res.data.data
              that.setMessage(res.data.data)
            }
          })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/personalCenter.scss";

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>